<div class="cost-breakdown-container">
  <div class="info-card">
      <span><strong>Field Details - {{ fieldName }}</strong></span>
      <p><strong>Number of Fields:</strong> {{ numberOfFields }} <span style="margin-left: 40px;"><strong>Total No of HA:</strong> {{ totalHectares | number:'1.2-2' }} HA</span> <span style="margin-left: 40px;"><strong>Country:</strong> {{ country }}</span></p>
  </div>
</div>
